import { Text } from "@imminently/react/ui/core/text";
import { InputBase, Stack } from "@mui/material";

import { MonitorIcon } from "@/assets/icons";
import { ATS_COLOURS } from "@/resources/constants";
import { PatientEncounter } from "@/resources/types";
import { css, Theme } from "@/theme";
import { useSettingsContext } from "@/pages/settings/SettingsProvider";
import { getTriageFromSettings, getTriageLevelColours } from "@/util/triage";

const styles = {
  atsBox: {
    padding: "1rem 1rem",
    marginBottom: 2,
    borderRadius: 1,
    maxHeight: "64px",
    alignItems: "center",
  },
  infoBoxRight: (theme: Theme) => css`
    font-family: "Baloo 2";
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 28px;
    flex: 1;

    > input {
      text-align: right;
      height: 28px;
      padding: 0;

      &.Mui-disabled {
        -webkit-text-fill-color: ${theme.palette.primary["900"]};
      }
    }

    &.Mui-disabled {
      color: ${theme.palette.primary["900"]};
    }
  `,
};


const PatientATSScore = (props: { encounter: PatientEncounter }) => {
  const { settings } = useSettingsContext();
  const triage = getTriageFromSettings(props.encounter.atsScore, settings);
  
  const colours = triage && getTriageLevelColours(triage.colourPalette);

  return (
    <Stack direction="row" spacing={1} sx={{ ...styles.atsBox, 
      border: `1px solid ${colours?.border}`,
      backgroundColor: colours?.backgroundBright,
      color: colours?.text,
    }}>
      <MonitorIcon style={{ verticalAlign: "middle" }} />
      <Text bold>ATS</Text>
      <InputBase css={styles.infoBoxRight} disabled value={triage?.label ?? "-"} />
    </Stack>
  );
};

export default PatientATSScore;
